import React, { createContext, useContext, useState, useCallback } from 'react';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [headerSearch, setHeaderSearch] = useState('');

  const clearHeaderSearch = useCallback(() => setHeaderSearch(''), []);

  return (
    <SearchContext.Provider value={{ headerSearch, setHeaderSearch, clearHeaderSearch }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useHeaderSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useHeaderSearch must be used within a SearchProvider');
  }
  return context;
};
